export default {"src":"/_next/static/media/toothCrack_40.3f0453fa.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};